import React from "react";

import "./Card.css";

const Card = ({ image, name, symbol, price, volume, pchange, mcap }) => {
    return (
        <tr className='card'>
            <td className='card_name'>
                <img src={image} alt={name} /> {name}
            </td>
            <td className='card_symbol'>{symbol}</td>
            <td>${price.toLocaleString()}</td>
            <td>${volume.toLocaleString()}</td>
            <td
                className={
                    pchange.toFixed(2) > 0
                        ? "card_price_high"
                        : "card_price_low"
                }>
                {pchange.toFixed(2)}%
            </td>
            <td>${mcap.toLocaleString()}</td>
        </tr>
    );
};

export default Card;
